// UI reducer for managing UI state like back button visibility and rate limits

// Action Types
export const SET_SHOW_BACK_TO_DASHBOARD_BUTTON = "SET_SHOW_BACK_TO_DASHBOARD_BUTTON";
export const SET_RATE_LIMIT = "SET_RATE_LIMIT";

// Initial state
const initialUIState = {
  showBacktoDashboardButton: false,
  rateLimit: null,
};

// UI reducer
const uiReducer = (state = initialUIState, action) => {
  switch (action.type) {
    case SET_SHOW_BACK_TO_DASHBOARD_BUTTON:
      return { ...state, showBacktoDashboardButton: action.payload };
    case SET_RATE_LIMIT:
      return { ...state, rateLimit: action.payload };
    default:
      return state;
  }
};

// Action creators
export const setShowBackToDashboardButton = (show) => ({
  type: SET_SHOW_BACK_TO_DASHBOARD_BUTTON,
  payload: show,
});

export const setRateLimit = (rateLimit) => ({
  type: SET_RATE_LIMIT,
  payload: rateLimit,
});

export default uiReducer;

